import { render } from "./OrganizationPicker.vue?vue&type=template&id=1dec20e2&ts=true"
import script from "./OrganizationPicker.vue?vue&type=script&lang=ts"
export * from "./OrganizationPicker.vue?vue&type=script&lang=ts"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__